import { Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import * as $ from  'jquery';
import Swal from 'sweetalert2' ;
import {Translatable} from "../../../../../Translatable";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {modules, sous_module} from "../../../../model/db";
import {valuesys} from "../../../../../../options";
import {environment} from "../../../../../../environments/environment";
import {DataTableDirective} from "angular-datatables";
@Component({
  selector: 'app-sous-module',
  templateUrl: './sous-module.component.html',
  styleUrls: ['./sous-module.component.css']
})
export class SousModuleComponent extends Translatable  implements  OnInit {
  //DATATABLE
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  title:string ;
  dtOptions: DataTables.Settings = {};
  modalRef: BsModalRef;
  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  public sousmodules :sous_module[] = [] ;
  public sousmodule:sous_module = new sous_module();
  public modules:modules [] = [];

  public sousmodule_error : sous_module ;

  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private httpClient: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService,
              private route: Router
  ) {
    super();
  }

  async ngOnInit() {
    this.auth.initAutority("SMDL");
    this.initDatatable()
  }
  initDatatable(){
    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_sousmodule");
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
      {
        "data": "name"
      },
      {
        "data": "code"
      },
      {
        "data": "module",
        "name" : "module.name",
      }
    ];
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
          .get<DataTablesResponse>(
              environment.sousmodule+"?child=module&" + $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
          ).subscribe(resp => {
        this.sousmodules = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }
  async toggleState(sousmodule:sous_module,state:number,btn:any){

    btn.disabled = true;
    let toogle = await this.http.get<any>(environment.sousmodule+`/${sousmodule.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      sousmodule.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }
  delete(deletedUser:sous_module,elm){
    elm.disabled = true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.sousmodule+"/" + deletedUser.id,valuesys.httpAuthOptions()).toPromise();
        // this.rerender();
        if(sup.code == 204){
          this.sousmodules= this.sousmodules.filter(function (item,index) {
            return item.id != deletedUser.id
          })
          Swal.fire(
              this.__('msg.deleted'),
              sup.msg,
              'success'
          )
        }else {
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
        elm.disabled = false

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        elm.disabled = false
        Swal.fire(
            this.__('msg.canceled'),
            this.__('msg.canceled_delete'),
            'error'
        )
      }
    })
  }


  async openModal(template:TemplateRef<any>,currenUser:sous_module =null,elem) {

    this.sousmodule_error = new sous_module()
    elem.disabled = true ;
    this.modules = await this.helper.getSelectList(environment.module,['name']);
    if(currenUser == null){
      this.isAdd = true ;
      this.sousmodule = new sous_module() ;
      this.titleModal = this.__('sousmodule.add') ;
    }else {

      this.isAdd = false ;
      this.titleModal = this.__('sousmodule.edit') ;
      this.sousmodule = currenUser ;

    }
    elem.disabled = false ;
    this.modalRef = this.modalService.show(template,{class:"modal-md",ignoreBackdropClick:true});

  }
  close(){
    this.modalRef.hide()
    this.isValid = false ;
    this.sousmodule = new sous_module()
    this.titleModal = this.__('sousmodule.edit') ;
    this.sousmodule_error = new sous_module();
  }
  async addUserForm(){
    this.sousmodule_error = new sous_module()
    this.isValid = true ;
    if(this.isAdd ){
      let res:any =  await this.http.post<any>(environment.sousmodule,this.sousmodule,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
        res.data.module = this.modules.find( _ => _.id == this.sousmodule.module_id) ;
        this.sousmodules.push( res.data);
        this.close()
      }else if(res.code === 400){
        for (let item in res.data){
          this.sousmodule_error[item] = res.data[item][0] ;
        }
        this.sousmodule_error = <sous_module> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {
      console.log(this.sousmodule);
      let res =  await this.http.put<any>( environment.sousmodule + '/'+this.sousmodule.id,this.sousmodule,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.sousmodule.module = this.modules.find((_) =>_.id == this.sousmodule.module_id);
        this.toastr.success(res.msg,this.__("msg.success")) ;
        this.close()
      }else if(res.code === 400){
        this.sousmodule_error = <sous_module> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;


  }



}
